module.exports = __webpack_public_path__ + "media/images/top/package/package-link-2-3259a8d634546236c233dce881e48771.png";